<template>
  <div v-if="suggestedList && suggestedList.length" class="article-suggested-list" :class="{'limit': showMore}">
    <h3 class="title">
      {{ $t('ARTICLE.RECOMMEND') }}
    </h3>
    <ul class="suggested-list">
      <li v-for="list in suggestedList" :key="list.id">
        <a :href="articleURL(list.id)" target="_blank" v-html="list.subject" />
      </li>
    </ul>
    <div v-if="suggestedList.length > 3" class="expand-more">
      <a v-if="showMore" herf="#" class="expand-btn" @click="showMore=false">
        <i class="material-icons icon">
          expand_more
        </i>
      </a>
      <a v-else herf="#" class="expand-btn" @click="showMore=true">
        <i class="material-icons icon">
          expand_less
        </i>
      </a>
    </div>
  </div>
</template>

<script>
import ArticleService from '@/assets/services/ArticleService'
import SearchService from '@/assets/services/SearchService'

export default {
  name: 'ArticleSuggested',
  components: {
  },
  directives: {},
  props: {
    keyword: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      suggestedList: [],
      showMore: true
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.getArticlesByKeyword()
  },
  updated() {},
  methods: {
    articleURL(articleId) {
      return `https://${process.env.VUE_APP_MUZIK_READ}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/articles/${articleId}`
    },
    async getArticlesByKeyword() {
      if (this.type === 'search') {
        let articles = await SearchService.getArticleBySearch(this.keyword, { size: 5, lang: this.$i18n.locale.toLowerCase(), sort: 0 })
        this.suggestedList = articles && articles.data && articles.data[0] && articles.data[0].article ? articles.data[0].article.map(article => {
          return {
            id: article.id,
            subject: article.subject
          }
        }) : []
      } else {
        let articles = await ArticleService.getArticlesByKeyword({ keyword: this.keyword, per_page: 5 })
        if (articles && articles.data) {
          this.suggestedList = articles.data
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.article-suggested-list{
  position: relative;
  margin: 0 0 24px;
  .title{
  font-size: 20px;
  color: $grey-6e;
  line-height: 36px;
  margin: 0;
  }
  .suggested-list{
    list-style: none;
    padding: 0;
    margin: 0;
    font-size: 20px;
    color: $grey-6e;
    line-height: 36px;
    li{
      position: relative;
      padding-left: 36px;
      &:before{
        content: '•';
        position: absolute;
        left: 12px;
        top: 0;
        bottom: 0;
        margin: auto;
      }
      a{
        color: $grey-6e;
        text-decoration: none;
        /deep/ .keyword{
          color: $grey-6e;
          font-weight: normal;
        }
      }
    }
  }
  .expand-more{
    position: relative;
    display: block;
    width: 100%;
    background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.8), #ffffff);
    text-align: center;
  }
  .expand-btn{
    position: relative;
    display: inline-block;
    color: $link-hover;
    cursor: pointer;
    margin-top: 20px;
  }
  &.limit{
    .suggested-list{
      max-height: 120px;
      overflow: hidden;
    }
    .expand-more{
      position: absolute;
      top: 110px;
    }
  }
}

@media only screen and (min-width: 1440px) {
  // As same as default
}

@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {
  // As same as default
}

@media only screen and (min-width: 768px) and (max-width: 1023.98px) {
  // As same as default
}

@media only screen and (max-width: 767.98px) {
  .article-suggested-list{
    .title,
    .suggested-list{
      font-size: 16px;
      line-height: 26px;
    }
  }

}
</style>
